import { useEffect, useState } from "react";
import { Phone, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { localize } from "@/utils/paths";
import { waLink, WhatsAppIcon } from "@/components/WhatsAppButton";

export const StickyCta = ({ lang = "de" }) => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const de = lang === "de";

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const nearBottom = y + window.innerHeight > document.body.scrollHeight - 600;
      setShow(y > 700 && !nearBottom);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e) => {
    e.preventDefault();
    navigate(localize("/", lang));
    setTimeout(() => {
      const el = document.querySelector("#kontakt");
      if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
      else if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 150);
  };

  return (
    <div
      data-testid="sticky-cta"
      aria-hidden={!show}
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 bg-ink text-cream border-t border-cream/10 grid grid-cols-3 transition-transform duration-500 ${
        show ? "translate-y-0" : "translate-y-full pointer-events-none"
      }`}
    >
      <a
        href="tel:+41446880380"
        data-testid="sticky-cta-call"
        className="flex items-center justify-center gap-1.5 py-4 text-xs font-semibold tracking-wide"
      >
        <Phone size={15} strokeWidth={1.5} />
        {de ? "Anrufen" : "Call"}
      </a>
      <a
        href={waLink(lang)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-cta-whatsapp"
        className="flex items-center justify-center gap-1.5 py-4 text-xs font-semibold tracking-wide bg-[#25D366] text-white"
      >
        <WhatsAppIcon size={15} />
        WhatsApp
      </a>
      <a
        href={localize("/", lang) + "#kontakt"}
        onClick={go}
        data-testid="sticky-cta-contact"
        className="flex items-center justify-center gap-1.5 py-4 text-xs font-semibold tracking-wide bg-taupe text-cream"
      >
        <Mail size={15} strokeWidth={1.5} />
        {de ? "Anfrage" : "Enquire"}
      </a>
    </div>
  );
};
